import { useApp } from "@/context/AppContext";
import { useSeo } from "@/lib/seo";
import { IMAGES } from "@/constants/images";
import { Reveal } from "@/components/Reveal";
import Marquee from "@/components/site/Marquee";

export default function About() {
  const { t } = useApp();
  useSeo("about");
  return (
    <div className="pt-32 md:pt-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 md:gap-20 items-center">
          <Reveal>
            <span className="text-sm font-semibold uppercase tracking-widest text-accent2">{t.nav.about}</span>
            <h1 className="mt-3 font-display font-black text-5xl md:text-7xl tracking-tighter leading-[0.95]">{t.about.title}</h1>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">{t.hero.sub}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="aspect-[4/5] overflow-hidden border border-slate-200 grain relative">
              <img src={IMAGES.craftsman} alt="" className="w-full h-full object-cover" />
            </div>
          </Reveal>
        </div>
      </div>

      <div className="mt-20 md:mt-28"><Marquee /></div>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32">
        <div className="grid md:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {t.about.chapters.map((c, i) => (
            <Reveal key={i} delay={i * 0.1} className="bg-white p-8 md:p-10">
              <span className="font-display font-black text-6xl text-slate-100 block leading-none">0{i + 1}</span>
              <h3 className="mt-4 font-display font-bold text-2xl">{c.t}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{c.d}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
